module.exports = __webpack_public_path__ + "static/img/background2.656f470.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/background2.jpg
// module id = H6tt
// module chunks = 0